import { render } from "./Settings.vue?vue&type=template&id=2cef05f2&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=2cef05f2&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cef05f2"]])

export default __exports__